import React, {Component} from 'react'
import Editor, { Editable, createEmptyState } from 'ory-editor-core'
import 'ory-editor-core/lib/index.css' // we also want to load the stylesheets
import { Trash, DisplayModeToggle, Toolbar } from 'ory-editor-ui'
import 'ory-editor-ui/lib/index.css'
import slate from 'ory-editor-plugins-slate' // The rich text area plugin
import 'ory-editor-plugins-slate/lib/index.css' // Stylesheets for the rich text area plugin
import parallax from 'ory-editor-plugins-parallax-background' // A plugin for parallax background images
import 'ory-editor-plugins-parallax-background/lib/index.css' // Stylesheets for parallax background images
import image from 'ory-editor-plugins-image'
import 'ory-editor-plugins-image/lib/index.css'
import Paper from '@material-ui/core/Paper'
import spacer from 'ory-editor-plugins-spacer'
import 'ory-editor-plugins-spacer/lib/index.css'
import divider from 'ory-editor-plugins-divider'
import 'ory-editor-plugins-divider/lib/index.css'
// The video plugin
import video from 'ory-editor-plugins-video'
import 'ory-editor-plugins-video/lib/index.css'
// The image plugin
import { imagePlugin } from 'ory-editor-plugins-image'
import 'ory-editor-plugins-image/lib/index.css'

// The background plugin
import background, { COLOR_MODE_FLAG, IMAGE_MODE_FLAG, GRADIENT_MODE_FLAG } from 'ory-editor-plugins-background'
import 'ory-editor-plugins-background/lib/index.css'

import { HTMLRenderer } from 'ory-editor-renderer'


// The html5-video plugin
import html5video from 'ory-editor-plugins-html5-video'
import 'ory-editor-plugins-html5-video/lib/index.css'
// The native handler plugin
//import native from '../ory-native-dnd'
import native from 'ory-editor-plugins-default-native'
import ax_ins from '../ajax'
import Vimeo from '@u-wave/react-vimeo'

const isEqual = require("react-fast-compare")

const ImageUploadService = (defaultUrl) => (file, reportProgress) => {
  return new Promise((resolve, reject) => {
  var formData = new FormData()
  formData.append("qqfilename",file.name)
  formData.append("qqfile", file)
  ax_ins.post('upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: progressEvent => console.log(progressEvent.loaded)
  }).then(data => {
    console.log(data.data)
    resolve({ url: 'https://ofb.rdhs.eu/rest/image/'+data.data.filename})
  })
})
}

// const plugins = {
//   content: [slate(), spacer, imagePlugin({ imageUpload: ImageUploadService() }), video, divider, html5video],
//   layout: [background({
//       defaultPlugin: slate(),
//       imageUpload: ImageUploadService(),
//       enabledModes: COLOR_MODE_FLAG | IMAGE_MODE_FLAG | GRADIENT_MODE_FLAG
//     }),
//   ],
//   native
// }

const plugins = {
content: [slate(), spacer, imagePlugin(), video, divider, html5video],
  layout: [background({
      defaultPlugin: slate(),
      imageUpload: ImageUploadService(),
      enabledModes: COLOR_MODE_FLAG | IMAGE_MODE_FLAG | GRADIENT_MODE_FLAG
    }),
  ],
  native
}




const editarea = {
  width : '80%',
  minHeight : '400px',
  marginLeft : 'auto',
  marginRight : 'auto'
}

const editable = createEmptyState()

const editor = new Editor({
  plugins: plugins,
  // pass the content states
  defaultPlugin: slate(),
  editables: [editable],
})

export default class LectureText extends Component {
  constructor(props){
    super(props)
    this.state = {
      EditorState : createEmptyState(),
      external : false,
      watching : false,
      current_timestamp : 0,
      //editor : new Editor({ EditorPlugins, defaultPlugin: slate(), editables: [createEmptyState()] })
    }
  }

  componentDidMount () {
    let s = this.props.socket
    const loop = () => {
      if (this.state.watching) {
        s.emit('watching video',{id:this.props.id,current_timestamp:this.state.current_timestamp})
      } else {
      }
      setTimeout(loop, 10000);
    }
    loop();

  }

  videoplaying  = (v)  => () => {
    this.setState({watching:v})
  }





  render() {
    return (
      <div style={{height:'100%',width:'100%'}}>
        {(this.props.editorplugin !== 'tinymce' && this.props.editorplugin !== 'video') &&  <HTMLRenderer state={this.props.text} plugins={plugins}/>}
        {this.props.editorplugin == 'tinymce' &&  <div dangerouslySetInnerHTML={{__html: this.props.text}}/>}
        {this.props.editorplugin == 'video' && 
            <div className='videocontainer' id={'videocontainer'}>
               <Vimeo video={this.props.text.link} responsive={true} start={this.props.currentTimestamp} onTimeUpdate={e => this.setState({current_timestamp:e.seconds})}
              onPause={this.videoplaying(false)} onPlay={this.videoplaying(true)} onEnd={this.videoplaying(false)}
              />
            </div>
        }
      </div>
      )
    
  }
}
